// react
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// context hooks
import useAsp from 'hooks/useAps';

// type
import { OrderType } from 'types/order';

const TownlifeTag = () => {
  const { isThanks, order } = useAsp();
  const { pathname } = useLocation();
  useEffect(() => {
    const scriptId = 'townlife';
    const isExsistScript = document.getElementById(scriptId);
    if (!!isExsistScript) isExsistScript.remove();
    const orderCode = order ? (order as OrderType).order_code : '';
    const script = document.createElement('script');
    script.id = scriptId;
    script.innerHTML = isThanks
      ? `
      var _CIDN = "cid";
      var _PMTV = "5b3058dbb6964";
      var _ARGS = "${orderCode}";
      var _TRKU = "https://townlife-aff.com/track.php?p=" + _PMTV + "&t=5b3058db&args=" + _ARGS;
      var _cks = document.cookie.split("; ");
      for(var i = 0; i < _cks.length; i++){ var _ckd = _cks[i].split( "=" ); if(_ckd[0] == "CL_" + _PMTV && _ckd[1].length > 1){ _TRKU += "&" + _CIDN + "=" + _ckd[1]; break; }}
      img = document.body.appendChild(document.createElement("img"));
      img.src = _TRKU;
      `
      : ``;
    document.body.appendChild(script);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
  return <></>;
};

export default TownlifeTag;
